// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2QFk8","colCheckbox":"styles_colCheckbox__2EuIC"};